import React from 'react'

const Background = ({children}) => {
  return (
    <div className='bg-main'>
        {children}
    </div>
  )
}

export default Background